import React, { Component } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import DataTable from "react-data-table-component";
import ManageTabSettings from "./ManageTabSettings";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";


class Payments extends Component {
  constructor() {
    super();
    this.state = {
      dataStartedProcessing: false,
      showLoader: false,
      dummyData: [
        {
          id: "1",
          name: "Jane",
          educationDate: "10/30/2023",
          educationDuration: this.randomNumber(1, 100),
          procedure: "Mastectomy",
          physician: "Dr. Sam Anderson",
          estimatedAmount: this.randomNumber(1, 1000)
        },
        {
          id: "2",
          name: "Alex",
          educationDate: "11/12/2023",
          educationDuration: this.randomNumber(1, 100),
          procedure: "Lumpectomy",
          physician: "Dr. Sam Anderson",
          estimatedAmount: this.randomNumber(1, 1000)
        },
      ],
      editedName: "",
      editedDescription: "",
      editedDheeProjectId: "",
      editedRuntimeUrl: "",
      editedInstanceId: "",
      disabled: false,
      editedId: "-1",
      pageNum: null,
      paginationValue: 10,
      hidden: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      searchTerm : ""
    }
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
  }
  componentDidMount() {
    var thisController = this;

    //   this.fetchVirtualAgentDetails();

    if (this.props.location.state != undefined) {
      this.setState({ pageNum: this.props.location.state.pageNum });
    }

  }
  addNewVirtualAgentRow = () => {
    var thisController = this;
    thisController.state.paginationValue = thisController.state.paginationValue + 5;
    if (thisController.state.pageNum != 0) {
      thisController.setState({ pageNum: 0 })
    }
    this.state.data.unshift({
      id: '',
      name: '',
      description: '',
      dheeProjectId: '',
      runtimeUrl: '',
      instanceId: ''
    });
    this.setState({
      data: this.state.data,
      disabled: true,
    })
  }

  makeCelledit(row, e) {
    this.markAsBeingEdited(row.id);
    this.state.editedName = row.name;
    this.state.editedDescription = row.description;
    this.state.editedDheeProjectId = row.dheeProjectId;
    this.state.editedRuntimeUrl = row.runtimeUrl;
    this.state.editedInstanceId = row.instanceId;
    this.setState(this.state);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }

  fetchVirtualAgentDetails = () => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/load-agents",
      method: 'GET',
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          var messages = res.result;
          thisController.state.disabled = false;
          thisController.state.showLoader = true;
          thisController.state.data = messages;
          thisController.data = messages;
          thisController.setState(thisController.state);
        } else {
          // thisController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      }
    });
  }

  saveVirtualAgentDetails(row, e) {
    var thisController = this;
    var namePattern = new RegExp(/^([a-zA-Z\s-])*$/);

    row.name = document.getElementById("name" + row.id).innerText.trim();
    row.description = document.getElementById("description" + row.id).innerText.trim();
    row.dheeProjectId = document.getElementById("dheeProjectId" + row.id).innerText.trim();
    row.runtimeUrl = document.getElementById("runtimeUrl" + row.id).innerText.trim();
    row.instanceId = document.getElementById("instanceId" + row.id).innerText.trim();


    var agentName = row.name;
    var projectId = row.dheeProjectId;
    var runtimeUrl = row.runtimeUrl;
    var instanceId = row.instanceId;
    if (agentName == "" || projectId == "" || runtimeUrl == "" || instanceId == "") {
      thisController.notifyMsgFieldEmpty();
    }
    else if (!namePattern.test(agentName)) {
      thisController.notifyImproperName();
    }

    else {
      thisController.state.editedId = "-1";
      thisController.state.dataStartedProcessing = true;
      thisController.setState(thisController.state);
      var saveData = {
        name: row.name,
        description: row.description,
        dheeProjectId: row.dheeProjectId,
        runtimeUrl: row.runtimeUrl,
        instanceId: row.instanceId
      }

      var timer = setInterval(function () {
        clearTimeout(timer);

        $.ajax({
          url: "/my-jeeva-api/add-virtual-agent",
          method: 'POST',
          headers: {
            'Authorization': "Bearer " + localStorage.getItem("access_token"),
            'Content-Type': "application/json",

          },
          data: JSON.stringify(saveData),
          success: function (res) {
            if (res.success === true) {
              thisController.state.dataStartedProcessing = false;
              thisController.notifyVirtualAgentAdded();
              thisController.fetchVirtualAgentDetails();
              thisController.setState({ disabled: false, dataStartedProcessing: false });
            } else {
              thisController.notifyFailedResponse(res.result);
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "";
            }
          }
        })

      }, 2000);
    }
  }

  updateVirtualAgentDetails(row, e) {
    row.name = document.getElementById("name" + row.id).innerText.trim();
    row.description = document.getElementById("description" + row.id).innerText.trim();
    row.dheeProjectId = document.getElementById("dheeProjectId" + row.id).innerText.trim();
    row.runtimeUrl = document.getElementById("runtimeUrl" + row.id).innerText.trim();
    row.instanceId = document.getElementById("instanceId" + row.id).innerText.trim();
    var thisController = this;

    var namePattern = new RegExp(/^([a-zA-Z\s-])*$/);


    var agentName = thisController.state.editedName;
    var agentDesc = thisController.state.editedDescription;
    var projectId = thisController.state.editedDheeProjectId;
    var agentRuntimeUrl = thisController.state.editedRuntimeUrl;
    var agentInstanceId = thisController.state.editedInstanceId;

    if (agentName == "" || projectId == "" || agentRuntimeUrl == "" || agentInstanceId == "") {
      thisController.notifyMsgFieldEmpty();
    }
    else if (!namePattern.test(agentName)) {
      thisController.notifyImproperName();
    }

    else {
      var updatedData = {
        id: row.id,
        name: agentName,
        description: agentDesc,
        dheeProjectId: projectId,
        runtimeUrl: agentRuntimeUrl,
        instanceId: agentInstanceId
      };
      $.ajax({
        url: "/my-jeeva-api/update-virtual-agent",
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(updatedData),
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            thisController.state.editedId = "-1";
            thisController.notifyVirtualAgentUpdate();
            thisController.fetchVirtualAgentDetails();
          } else {
            thisController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        }


      })
    }

  }
  openDeletePopUp = (id) => {

    confirmAlert({
      title: 'Confirm to Delete',
      message: 'Are you sure to delete this? ',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.callDeleteVirtualAgentApi(id)
        },
        {
          label: 'No',
        }
      ]
    });
  }


  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no payment data present. </p>
    </div>
  );

  callDeleteVirtualAgentApi = (id) => {
    let virtualAgentData = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      virtualAgentData.splice(id, 1);
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-virtual-agent/" + id,

        method: 'DELETE',
        headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {

          if (res.success === true) {

            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.notifyDelete();
            virtualAgentData.splice(id, 1);
            deleteApiViewController.refreshData();
          } else {
            // virtualAgentData.notifyError();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        }
      });
    }

    if (this.state.deleteRow) {
      this.state.data.splice(id, 1);
    }
    deleteConstructorVariables.fetchVirtualAgentDetails();


  }
  notifyError() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
      position: "top-center"
    });
  }

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red"

    });
  }

  notifyDataProcessing() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Hold on.Your data is saving...
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyVirtualAgentAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Virtual Agent Details added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyVirtualAgentUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Virtual Agent Details updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperName() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please provide a valid name</b>, {
      position: "top-center"
    });
  }

  notifyDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Virtual Agent Detail deleted successfully</b>, {
      position: "top-center",
    });
  }

  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please fill all the fields</b>, {
      position: "top-center"
    });

  }
  refreshData = (id) => {
    console.log("Resetting the data");
    this.state.data = [];
    this.state.editedId = "-1";
    this.state.disabled = false;
    this.setState(this.state);
    this.fetchVirtualAgentDetails();
  }

  handleNameChange = (e) => {
    this.state.editedName = e.currentTarget.textContent.trim();
    this.setState(this.state);
  }

  handleDescriptionChange = (e) => {
    this.state.editedDescription = e.currentTarget.textContent.trim();
    this.setState(this.state);
  }

  handleDheeProjectIdChange = (e) => {
    this.state.editedDheeProjectId = e.currentTarget.textContent.trim();
    this.setState(this.state);
  }

  handleRuntimeUrlChange = (e) => {
    this.state.editedRuntimeUrl = e.currentTarget.textContent.trim();
    this.setState(this.state);
  }

  handleInstanceIdChange = (e) => {
    this.state.editedInstanceId = e.currentTarget.textContent.trim();
    this.setState(this.state);
  }

  addVirtualAgentSkills = (row, e) => {
    this.props.history.push({
      pathname: '/projectmgmt/virtual-agent-skills',
      state: {
        virtualAgentId: row.id,
        VirtualAgentName: row.name,
        pageNum: this.state.pageNum
      }
    });
    this.setState(this.setState)
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }

  randomNumber(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  caseInsensitiveSort = (field) => (rowA, rowB) => {
    var a;
    var b;
    if (field === "estimatedAmount" || field === "educationDuration") {
      a = rowA[field];
      b = rowB[field];
    } else {
      a = rowA[field].toLowerCase();
      b = rowB[field].toLowerCase();
    }

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  handleSearch = (event) => {
    var thisController = this;
    thisController.state.searchTerm = event.target.value;
    thisController.state.isLoading = true;
    thisController.state.data = [];
    thisController.setState(thisController.state);

    $.ajax({
      url: "/my-jeeva-api/search-health-system-data",
      method: "GET",
      data: {
        searchTerm: thisController.state.searchTerm
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          if (res.result.length > 0) {
            thisController.state.data = [];
            thisController.setState(thisController.state);
            thisController.state.data = res.result;
            thisController.state.isLoading = false;
            thisController.setState(thisController.state);
          }
        }
      },
      error: function (xhr) {

      },
    });

  };

  render() {
    const { data } = this.state;
    var agentController = this;

    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}>Name</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('name'),
        selector: (row) => (
          <div name="name">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              id={"name" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.name}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Education Date</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('educationDate'),
        selector: (row) => (
          <div name="date">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id === "" || row.id === this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id === "" ? "2px" : "none",
                display: row.id === this.state.editedId ? "none" : "block",
              }}
              id={"date" + row.id}
              contentEditable={
                !(row.id === "" ? false : row.id !== this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.educationDate}
            </div>
            {row.id === this.state.editedId && (
              <DatePicker
                style={{
                  width: "10px",
                  marginLeft: "70%",
                  cursor: "pointer",
                }}
                portalId="root"
                autoOk={true}
                id={"admissionDate" + row.id}
                selected={this.state.selectedAdmissionDate}
                //   onChange={this.onAdmissionDateChange}
                dateFormat="MM/dd/yyyy"
              />
            )}
          </div>
        ),
      },

      {
        name: <b style={{ fontSize: "16px" }}>Education Duration</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('educationDuration'),
        selector: (row) => (
          <div name="time">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id === "" || row.id === this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                display: row.id === this.state.editedId ? "none" : "block",
              }}
              id={"time" + row.id}
              contentEditable={
                !(row.id === "" ? false : row.id !== this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.educationDuration}
            </div>
            {row.id === this.state.editedId && (
              <input
                type="time"
                className="form-control col-11"
                id="admissionTime"
                name="time"
                placeholder="Enter Time"
                value={this.state.admissionTime}
                style={{
                  width: "95%",
                  cursor: "pointer",
                  border: "1px solid #D2D4DC",
                  borderRadius: "4px",
                }}
              //   onChange={this.handleChangeAdmissionTime}
              />
            )}
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Treatment</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('procedure'),
        selector: (row) => {
          const isEditing = row.id === this.state.editedId;
          const element = isEditing ? (
            <select
              className="input-group form-control select2 "
              onChange={(e) => this.onChangeOfProcedure(row, e)}
              value={row.procedureId}
              id={"procedureId" + row.id}
              style={{
                marginLeft: "0vw",
                padding: "0px",
                paddingTop: "5px",
                paddingLeft: "5px",
                background: "white",
                border: "1px solid #D2D4DC",
                borderRadius: "2px",
              }}
            >
              {this.proceduresByServiceLine[row.serviceLineId] ? (



                this.proceduresByServiceLine[row.serviceLineId].map(
                  (procedureData) => (
                    <option key={procedureData} value={procedureData["id"]}>
                      {procedureData["name"]}
                    </option>
                  )
                )
              )
                : (
                  <option key="" value="">
                    No Option
                  </option>
                )}
            </select>
          ) : (
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border: "none",
                overflow: "hidden",
              }}
            >
              {row.procedure}
            </div>
          );
          return (
            <div className="container-fluid" style={{ textAlign: "left" }}>
              {element}
            </div>
          );
        },
      },

      {
        name: <b style={{ fontSize: "16px" }}>Provider</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('physician'),
        selector: (row) => {
          const isEditing = row.id === this.state.editedId;
          const element = isEditing ? (
            <select
              className="input-group form-control select2"
              onChange={(e) => this.onChangeOfPhysician(row, e)}
              value={row.physicianId}
              id={"physicianId" + row.id}
              style={{
                marginLeft: "0vw",
                padding: "0px",
                paddingTop: "5px",
                paddingLeft: "5px",
                background: "white",
                border: "1px solid #D2D4DC",
                borderRadius: "2px",
              }}
              disabled={row.id === "" ? false : row.id !== this.state.editedId}
            >
              {this.physiciansByServiceLine[row.serviceLineId] ? (
                this.physiciansByServiceLine[row.serviceLineId].map(
                  (physicianData) => (
                    <option key={physicianData} value={physicianData["id"]}>
                      {physicianData["userName"]}
                    </option>
                  )
                )
              ) : (
                <option key="" value="">
                  No Option
                </option>
              )}
            </select>
          ) : (
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border: "none",
                overflow: "hidden",
              }}
            >
              {row.physician}
            </div>
          );
          return (
            <div className="container-fluid" style={{ textAlign: "left" }}>
              {element}
            </div>
          );
        },
      },
      {
        name: <b style={{ fontSize: "16px" }}>Estimated Amount</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('estimatedAmount'),
        selector: (row) => (
          <div name="estimatedAmount">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              id={"estimatedAmount" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.estimatedAmount}
            </div>
          </div>
        ),
      },

    ];
    return (
      <div style={{ background: "#F9F9FB", marginRight: "1%" }}>
        {/* for toaster */}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        {/* for reactTable */}
        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


        {/*for dialog component */}
        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        {/* Font Awesome Icons */}
        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
        {/* IonIcons */}
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
        {/* Select2 */}
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        <link rel="stylesheet" href="assets/css/toggleButton.css" />
        <link rel="stylesheet" href="./assets/css/styles.css" />
        <div className="row" style={{ marginLeft: "15px" }}>
          <div className="col-sm-4" style={{ marginTop: '2px' }} >

          </div>
        </div>

        <div className="row" style={{ marginLeft: '14px' }}>
          <div className="col-sm-5">
            <h6 className="nav-item" style={{ color: '#282a65' }}>
              Payments</h6>
          </div>
          <div className="col-sm-5" Align="right">
            <input
              type="text"
              style={{
                width: "12vw",
                border: "2px solid #777676",
                borderRadius: "10px",
                padding: "10px",
                height: "0.7vw"
              }}
              value={this.state.searchTerm}
              // onChange={this.handleSearch}
              placeholder="Search ..."
            />
          </div>
          <div className="col-sm-2 " id='addrefresh-btn' style={{ marginTop: '-18px' }}>
            <div className="d-flex flex-row-reverse pt-2">

              <div className="p-2" style={{ marginBottom: '10px' }}>

                {/* <button className="btn action-button"
                  id="addMsg" title=" Add "
                // onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addNewVirtualAgentRow}
                >
                  <img src="assets/images/add_white_24dp.png" />
                </button>
                <button title="Refresh"
                  //   onClick={this.refreshData} 
                  type="button" className="btn action-button">
                  <img src="./assets/images/refresh_white_24dp.png"></img>
                </button> */}
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginLeft: '15px', marginTop: '5px' }}>
          <div className="col-lg-12 ">
            <div className="card">
              <DataTable
                data={this.state.dummyData}
                columns={columns}
                defaultPageSize={10}
                pageSizeOptions={[5, 10, 15]}
                pagination={this.state.paginationValue}
                onPageChange={this.onPageChange}
                page={this.state.pageNum}
                noDataComponent={<this.CustomNoDataComponent />}

              />
            </div>
            <ToastContainer className="Toast-at-center" />
          </div>
        </div>
      </div>
    )
  }
}


export default Payments;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Payments.js